import * as wf from "client-api-workflow";
import { isValidId } from "qpr-base/utils/url-utils";
import { useQuery } from "react-query";

const useAttachments = (params: { elementId?: string; period?: string }) => {
  return useQuery(
    `data-file-attachments-${params.elementId}-${params.period}`,
    () => {
      return wf.getAttachments({
        period: params.period || "",
        parentId: params.elementId || "",
      });
    },
    {
      enabled: isValidId(params.elementId || "") && !!params.period,
      staleTime: 2000,
    }
  );
};

export default useAttachments;
